module.exports = __webpack_public_path__ + "media/images/logos/zoom-7e3648a9521577e0a9eb8e71e92557b4.png";